import React, { FC } from 'react';
import { GRID_GAP } from '../utils/tileGenerator';
import { getGridPixelSize, getTileDisplayWidth, TILE_BORDER_RADIUS } from '../utils/tileLayout';
import { COLORS } from '../utils/colors';
import EdgeConnectorOverlay from './EdgeConnectorOverlay';

type GridProps = {
  columns: number;
  children: React.ReactNode;
  tileSize?: number;
  gameTiles?: string[];
  showMatchingEdges?: boolean;
};

const Grid: FC<GridProps> = ({
  children,
  columns,
  tileSize = getTileDisplayWidth(),
  gameTiles = [],
  showMatchingEdges = false,
}) => {
  const childCount = React.Children.count(children);
  const { width, height } = getGridPixelSize(childCount, columns, tileSize, GRID_GAP);

  return (
    <div
      style={{
        padding: GRID_GAP,
        backgroundColor: COLORS.GRID_BACKDROP,
        borderRadius: TILE_BORDER_RADIUS + GRID_GAP,
        margin: 'auto',
        display: 'inline-block',
      }}
    >
      <div
        style={{
          position: 'relative',
          display: 'grid',
          gridTemplateColumns: `repeat(${columns}, ${tileSize}px)`,
          gridGap: GRID_GAP,
          width,
          height,
          overflow: 'visible',
        }}
      >
        <EdgeConnectorOverlay
          tiles={gameTiles}
          columns={columns}
          tileSize={tileSize}
          show={showMatchingEdges}
        />
        {children}
      </div>
    </div>
  );
};

export default Grid;
